export enum AuthTabs {
  'SIGN_IN' = 'SIGN_IN',
  'SIGN_UP' = 'SIGN_UP',
}

export enum UserStatus {
  'ACTIVE' = 'active',
  'INACTIVE' = 'inactive',
}

export enum UserRole {
  'USER' = 'user',
  'OWNER' = 'owner',
}
